import {FREEZE_WIZARD} from "../types";

export const freezeWizard = (element) => dispatch => {
    dispatch({
        type: FREEZE_WIZARD,
        payload: element
    })
}


// WEBPACK FOOTER //
// ./src/actions/WizardActions/FreezeWizard.js